export const translations = {
  ar: {
    appName: "سُلفة", tagline: "سلفة جماعية بنظام تكافل اجتماعي",
    subtitle: "تكافل بين الأعضاء، قرعة شفافة وعادلة لاختيار دور الاستلام، ومكافآت ولاء للمشاركين",
    getStarted: "ابدأ الآن", login: "تسجيل الدخول", register: "حساب جديد", logout: "خروج",
    dashboard: "سُلفة | SULFA", pools: "السلف", createPool: "إنشاء سلفة",
    wallet: "المحفظة", earn: "اربح", kyc: "توثيق", admin: "الإدارة",
    notifications: "الإشعارات", profile: "الملف الشخصي",
    freeRoulette: "هدية مجانية 🎁", games: "العاب وتحديات",
    comingSoon: "قريباً", markAllRead: "وضع علامة مقروء",
    noNotifications: "لا توجد إشعارات",
    email: "البريد", password: "كلمة المرور", name: "الاسم",
    phone: "رقم الهاتف", refCode: "كود الإحالة (اختياري)", country: "المنطقة",
    submit: "إرسال", continueGoogle: "متابعة بحساب جوجل", or: "أو",
    balance: "الرصيد", coins: "النقاط", xp: "الخبرة",
    yourTier: "مستواك", nextTier: "التالي",
    activePool: "سلفات نشطة", winnings: "الأرباح", recentActivity: "آخر النشاطات",
    poolName: "اسم السلفة", amountPerRound: "مبلغ الجولة", memberCount: "عدد الأعضاء",
    frequency: "التكرار", daily: "يومي", monthly: "شهري",
    description: "الوصف", create: "إنشاء",
    join: "انضمام", members: "الأعضاء", draws: "السحوبات", spin: "ابدأ السحب",
    winner: "الفائز", payout: "المكافأة", paymentMethod: "طريقة الدفع",
    deposit: "إيداع", withdraw: "سحب", amount: "المبلغ", destination: "الوجهة",
    transactions: "المعاملات",
    uploadId: "رفع صورة الهوية", kycPending: "قيد المراجعة", kycApproved: "موثّق",
    kycRejected: "مرفوض", kycNotSubmitted: "غير مُقدّم",
    watchAd: "شاهد إعلان", redeem: "استبدال النقاط",
    coinsRate: "كل 100 نقطة = 1$",
    howItWorks: "كيف يعمل",
    step1: "1- وثّق هويتك واشحن رصيدك", step2: "2- ادخل سلفة ضمن مستواك",
    step3: "3- ادفع جولتك وانتظر الروليت", step4: "4- اربح وارتقِ",
    trustTitle: "موثوق وآمن", trustDesc: "توثيق + منع تعدد الحسابات",
    pendingKyc: "وثّق هويتك أولاً",
    full: "ممتلئة", open: "مفتوحة", active: "نشطة", completed: "مكتملة",
    noPools: "لا توجد سلف", yourBalance: "رصيدك", requiredKyc: "التوثيق مطلوب",
    chooseLang: "اللغة", backToHome: "العودة",
    pendingReview: "في انتظار مراجعة الأدمن",
    contribute: "ادفع قسط الجولة", paid: "مدفوع", notPaid: "غير مدفوع",
    round: "الجولة", lockedTier: "مقفول - تحتاج مستوى أعلى",
    referralCode: "كود الإحالة", copyRef: "انسخ", copied: "تم النسخ",
    tierBronze: "برونزي", tierSilver: "فضي", tierGold: "ذهبي", tierSuper: "سوبر",
    maxPool: "أقصى سلفة", minPool: "أدنى سلفة",
    unlockNext: "افتح سلف أكبر",
    allMustPay: "يجب أن يدفع جميع الأعضاء قبل بدء قرعة هذه الجولة",
    revenue: "الإيرادات", grandTotal: "الإجمالي",
    poolEnded: "السلفة انتهت — يفتح المجال غداً لسلفة جديدة بنفس الأعضاء",
    // ads
    shortAd: "إعلان قصير 15ث", mediumAd: "إعلان متوسط 30ث", longAd: "إعلان طويل 60ث",
    adsWatched: "إعلانات مشاهدة", adsNeeded: "لمكافأة الولاء",
    // loyalty draw
    spinFree: "احصد مكافأتك", winRangeFor: "نطاق مكافأة الولاء لمستواك",
    needMoreAds: "تحتاج مشاهدة المزيد من الإعلانات",
    // wallet
    withdrawLocked: "يجب الانضمام لسلفة واحدة على الأقل قبل السحب",
    addWalletNumbers: "أضف أرقام محافظك",
    zaincashNumber: "رقم زين كاش", superqiNumber: "رقم سوبر كي",
    iraqiOnly: "للعراقيين فقط (مفتاح +964 أو 07)",
    intlOnly: "خارج العراق - TRX/USDT فقط",
    platformReceiveNum: "رقم استلام التطبيق",
    selectMethod: "اختر طريقة",
    sendTo: "حوّل إلى",
    // games
    gamesDesc: "تحديات ودّية بين الأعضاء — الفائز يربح والباقي يُكافأ بنقاط",
    bet: "مشاركة", challenge: "تحدّي",
    // loyalty
    rouletteLockedDesc: (n) => `شاهد ${n} إعلانات لفتح مكافأة الولاء`,
    monthlyDraw: "دور الاستلام الشهري",
    welcomeTitle: "مرحباً 👋",
  },
  en: {
    appName: "SULFA", tagline: "Cooperative group lending — social solidarity (Takaful)",
    subtitle: "Members support each other; transparent fair draw decides each turn; loyalty rewards for participants",
    getStarted: "Get Started", login: "Sign In", register: "Create Account", logout: "Logout",
    dashboard: "سُلفة | SULFA", pools: "Pools", createPool: "Create Pool",
    wallet: "Wallet", earn: "Earn", kyc: "KYC", admin: "Admin",
    notifications: "Notifications", profile: "Profile",
    freeRoulette: "Free Gift 🎁", games: "Play & Challenge",
    comingSoon: "Coming Soon", markAllRead: "Mark all read",
    noNotifications: "No notifications",
    email: "Email", password: "Password", name: "Name",
    phone: "Phone", refCode: "Referral Code (optional)", country: "Region",
    submit: "Submit", continueGoogle: "Continue with Google", or: "or",
    balance: "Balance", coins: "Coins", xp: "XP",
    yourTier: "Your Tier", nextTier: "Next",
    activePool: "Active Pools", winnings: "Winnings", recentActivity: "Recent",
    poolName: "Pool Name", amountPerRound: "Amount per Round", memberCount: "Members",
    frequency: "Frequency", daily: "Daily", monthly: "Monthly",
    description: "Description", create: "Create",
    join: "Join", members: "Members", draws: "Turns", spin: "Run Fair Draw",
    winner: "Recipient", payout: "Receivable", paymentMethod: "Payment",
    deposit: "Deposit", withdraw: "Withdraw", amount: "Amount", destination: "Destination",
    transactions: "Transactions",
    uploadId: "Upload ID", kycPending: "Pending", kycApproved: "Verified",
    kycRejected: "Rejected", kycNotSubmitted: "Not Submitted",
    watchAd: "Watch Ad", redeem: "Redeem", coinsRate: "100 coins = $1",
    howItWorks: "How It Works",
    step1: "1- Verify ID & top up", step2: "2- Join a pool in your tier",
    step3: "3- Pay round & spin", step4: "4- Win & level up",
    trustTitle: "Trusted & Secure", trustDesc: "KYC + anti multi-account",
    pendingKyc: "Verify ID first",
    full: "Full", open: "Open", active: "Active", completed: "Completed",
    noPools: "No pools", yourBalance: "Balance", requiredKyc: "KYC Required",
    chooseLang: "Language", backToHome: "Back",
    pendingReview: "Awaiting admin",
    contribute: "Pay Round", paid: "Paid", notPaid: "Unpaid",
    round: "Round", lockedTier: "Locked — need higher tier",
    referralCode: "Referral Code", copyRef: "Copy", copied: "Copied",
    tierBronze: "Bronze", tierSilver: "Silver", tierGold: "Gold", tierSuper: "Super",
    maxPool: "Max Pool", minPool: "Min Pool",
    unlockNext: "Unlock bigger pools",
    allMustPay: "All members must pay before roulette",
    revenue: "Revenue", grandTotal: "Grand Total",
    poolEnded: "Pool ended — new pool opens tomorrow",
    shortAd: "Short ad 15s", mediumAd: "Medium ad 30s", longAd: "Long ad 60s",
    adsWatched: "Ads watched", adsNeeded: "for loyalty reward",
    spinFree: "Claim Reward", winRangeFor: "Loyalty range for your tier",
    needMoreAds: "Watch more ads",
    withdrawLocked: "You must join at least one pool before withdrawing",
    addWalletNumbers: "Add your wallet numbers",
    zaincashNumber: "Zain Cash Number", superqiNumber: "Super Qi Number",
    iraqiOnly: "Iraqi users only (+964 or 07)",
    intlOnly: "International users - TRX/USDT only",
    platformReceiveNum: "Platform receive number",
    selectMethod: "Select method", sendTo: "Send to",
    gamesDesc: "Friendly challenges between members — winner takes, others earn points",
    bet: "Contribution", challenge: "Challenge",
    rouletteLockedDesc: (n) => `Watch ${n} ads to unlock loyalty reward`,
    monthlyDraw: "Monthly Turn",
    welcomeTitle: "Welcome 👋",
  }
};

export const PAYMENT_METHODS_IQ = [
  { id: "zaincash", label_ar: "زين كاش", label_en: "Zain Cash", icon: "📱" },
  { id: "super_qi", label_ar: "سوبر كي", label_en: "Super Qi", icon: "🟦" },
];
export const PAYMENT_METHODS_INTL = [
  { id: "trx",  label_ar: "ترون TRX", label_en: "TRON (TRX)", icon: "🔷" },
  { id: "usdt", label_ar: "تيثر USDT", label_en: "Tether (USDT)", icon: "🟢" },
];
export const ALL_PAYMENT_METHODS = [...PAYMENT_METHODS_IQ, ...PAYMENT_METHODS_INTL];

export const TIERS = {
  bronze: { min_xp: 0,     min_pool: 5,   max_pool: 20,   label_ar: "برونزي", label_en: "Bronze", cls: "tier-bronze", roulette_min: 0, roulette_max: 1 },
  silver: { min_xp: 3000,  min_pool: 50,  max_pool: 100,  label_ar: "فضي",    label_en: "Silver", cls: "tier-silver", roulette_min: 1, roulette_max: 5 },
  gold:   { min_xp: 15000, min_pool: 100, max_pool: 500,  label_ar: "ذهبي",   label_en: "Gold",   cls: "tier-gold",   roulette_min: 5, roulette_max: 15 },
  super:  { min_xp: 999999,min_pool: 1000,max_pool: 5000, label_ar: "سوبر",   label_en: "Super",  cls: "tier-gold opacity-60", roulette_min: 0, roulette_max: 0 },
  admin:  { min_xp: 0,     min_pool: 0,   max_pool: 999999, label_ar: "رسمية", label_en: "Official", cls: "bg-[#D4AF37]/15 text-[#D4AF37] border border-[#D4AF37]/30", roulette_min: 0, roulette_max: 0 },
};
export const getTier = (xp = 0) => xp >= 15000 ? "gold" : xp >= 3000 ? "silver" : "bronze";
